'use client';

import { useState } from 'react';
import {
  FooterState,
  getFooterHeaderModel,
} from './footerModels';
import type { FooterHeaderModel } from './footerModels';

interface UseFooterActionsInput {
  onRevealEmailClick?: () => void;
  onAboutUsClick?: () => void;
  onPrivacyClick?: () => void;
  onTermsClick?: () => void;
}

export interface FooterActionsController {
  footerState: FooterState;
  headerModel: FooterHeaderModel;
  handleRevealEmail: () => void;
  handleAboutUs: () => void;
  handlePrivacy: () => void;
  handleTerms: () => void;
}

export function useFooterActions({
  onRevealEmailClick,
  onAboutUsClick,
  onPrivacyClick,
  onTermsClick,
}: UseFooterActionsInput): FooterActionsController {
  const [footerState, setFooterState] = useState<FooterState>(FooterState.Default);

  const handleRevealEmail = (): void => {
    setFooterState(FooterState.EmailRevealed);
    onRevealEmailClick?.();
  };

  const handleAboutUs = (): void => {
    setFooterState(FooterState.AboutUs);
    onAboutUsClick?.();
  };

  const handlePrivacy = (): void => {
    onPrivacyClick?.();
  };

  const handleTerms = (): void => {
    onTermsClick?.();
  };

  return {
    footerState,
    headerModel: getFooterHeaderModel({ footerState }),
    handleRevealEmail,
    handleAboutUs,
    handlePrivacy,
    handleTerms,
  };
}
